import { useEffect, useMemo, useState } from "react";
import axios from "axios";
import { devURL } from "../../utils";

function useAnnouncements() {
  const [announcements, setAnnouncements] = useState([]);
  const token = localStorage.getItem("swToken");
  useEffect(() => {
    const cachedAnnouncements = sessionStorage.getItem("announcements");
    if (cachedAnnouncements) {
      setAnnouncements(JSON.parse(cachedAnnouncements));
    } else if (window.location.pathname === "/Dashboard") {
      axios
        .get(`${devURL}/user/getAnnounce`, { headers: { token } })
        .then((res) => {
          setAnnouncements(res.data.announcement);
          sessionStorage.setItem(
            "announcements",
            JSON.stringify(res.data.announcement)
          );
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, []);

  const memoizedAnnouncements = useMemo(() => announcements, [announcements]);

  return memoizedAnnouncements;
}

export default useAnnouncements;
